import { FC } from 'react';

import TaskCompletedImageSource from '../../../../assets/images/task-completed.png';
import { Container, DoneButton, TaskCompletedImage, TaskCompletedText } from './styled';

interface Props {
    onNextTaskClicked?: () => void;
}

const TaskCompleted: FC<Props> = ({ onNextTaskClicked }: Props) => {
    const handleNextTask = () => {
        onNextTaskClicked?.();
    };

    return (
        <Container>
            <img src={TaskCompletedImageSource} style={TaskCompletedImage} />
            <TaskCompletedText>
                    Thank you! Your work has been submitted.
            </TaskCompletedText>
            <DoneButton
                onClick={handleNextTask}
                variant="contained"
                color="primary"
                sx={{ mt: 2 }}
            >
                Next task
            </DoneButton>
        </Container>
    );
};

export default TaskCompleted;
